import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'taskPipeline',
  setup(__props) {

// 暂时没有纯在的必要
const colors = ref([
  '#F6CBC0',
  '#F1A09E',
  '#F0A0A8',
  '#EFAA97',
  '#246B69',
  '#CBE0F4',
  '#9BC4E0',
  '#E5E1EB',
  '#E3D7E6',
  '#C7C9E0',
  '#DBE1F0',
  '#ABCCDD',
  '#75A5B8',
  '#A7D0D8',
  '#E0C323',
  '#DEEBEC',
  '#BED9DD',
  '#AECFD0',
  '#73B3B2',
  '#3C979F',
  '#F1CCE1',
  '#DFABCF',
  '#8FD2E6',
  '#5D7AB5',
  '#EBCDA7',
  '#EEACCB',
  '#E094B2',
  '#954B63',
  '#ADC0DA',
  '#7083A6',
])
function randomFrom(min?: number, max?: number) {
  min = min ?? 0
  max = max ?? colors.value.length
  return Math.floor(Math.random() * (min - max + 1) + max)
}
const list = ref<any[]>([])
const dealViewList = computed<{ content: string; gradient: string }[]>(() => {
  return list.value.map((it) => {
    if (!it.gradient) {
      const right = colors.value[randomFrom()]
      const left = colors.value[randomFrom()]
      const gradient = `linear-gradient(to right, ${right} , ${left})`
      it.gradient = gradient
    }
    return it
  })
})
// setInterval(() => {
//   list.value.push({ content: '这是一条用于显示的内容' })
// }, 1000)

return { __sfc: true,colors, randomFrom, list, dealViewList }
}

})